import React from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Select from "react-select"; // Import react-select
// import axios from "axios";
import { useJwt } from "react-jwt";
import {
  // AdminLogin,
  CreateProduct,
  GetProductCatWithoutPage,
  GetProductSubCatWithoutPage,
  getallbrandnamewithoutpagination,
  getAllTags
} from "../apiconfig/authService";

function AddProduct(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setProductViewMessage = props.setMessage;
  const [productName, setProductName] = useState("");
  const [productWeight, setProductWeight] = useState("");
  const [swiggyweight, setSwiggyweight] = useState("");
  const [categoryID, setCategoryID] = useState(-1);
  const [subcategoryID, setSubcategoryID] = useState(-1);
  const [jiomartID, setJiomartID] = useState("");
  const [blinkitID, setBlinkitID] = useState("");
  const [bigbasketID, setBigbasketID] = useState("");
  const [zeptoID, setZeptoID] = useState("");
  const [jiomartUrl, setJiomartUrl] = useState("");
  const [dmartweight, setDmartweight] = useState("");
  const [swiggyInstaMartID, setSwiggyInstaMartID] = useState("");
  const [dMartID, setDMartID] = useState("");
  const [description, setDescription] = useState("");
  const [amazonID, setAmazonID] = useState("");
  const [flipkartID, setFlipkartID] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [categories, setCategories] = useState();
  const [subcategories, setSubcategories] = useState();
  const [visibleSubcategories, setVisibleSubcategories] = useState();
  const [isExoticProduct, setIsExoticProduct] = useState(false);
  const [isLastMinuteAddOn, setIsLastMinuteAddOn] = useState(false);
  const [isBestSellers, setIsBestSellers] = useState(false);
  const [isHotDeals, setIsHotDeals] = useState(false);
  const [isPopularProduct, setIsPopularProduct] = useState(false);
  const [isTrendingInYourArea, setIsTrendingInYourArea] = useState(false);
  const [isTrendingOffers, setIsTrendingOffers] = useState(false);
  const [isHealthySnacking, setIsHealthySnacking] = useState(false);
  // const [isbestsellerstitle, setIsbestSellersTitle] = useState("");
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState("");
  const [allTags, setAllTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const itemsPerPage = 500;

  const handleProductNameChange = (e) => {
    setProductName(e.target.value);
  };

  // const handleIsbestSellersTitleOnChange = (e) => {
  //   setIsbestSellersTitle(e.target.value);
  // };

  const handleProductWeightChange = (e) => {
    setProductWeight(e.target.value);
  };
  const handleSwiggyWeight = (e) => {
    setSwiggyweight(e.target.value);
  };
  const handleCategoryIDChange = (e) => {
    setCategoryID(Number(e.target.value));
    setSubcategoryID(-1);
    setVisibleSubcategories(
      subcategories.filter((item) => item.categoryid === e.target.value)
    );
  };

  const handleSubcategoryIDChange = (e) => {
    setSubcategoryID(Number(e.target.value));
  };

  const handleJiomartIDChange = (e) => {
    setJiomartID(e.target.value);
  };

  const handleBlinkitIDChange = (e) => {
    setBlinkitID(e.target.value);
  };

  const handleBigbasketIDChange = (e) => {
    setBigbasketID(e.target.value);
  };

  const handleZeptoIDChange = (e) => {
    setZeptoID(e.target.value);
  };
  const handleJiomartUrlChange = (e) => {
    setJiomartUrl(e.target.value);
  };
  const handleDmartUrlChange = (e) => {
    setDmartweight(e.target.value);
  };
  const handleSwiggyInstaMartIDChange = (e) => {
    setSwiggyInstaMartID(e.target.value);
  };
  const handleDMartIDChange = (e) => {
    setDMartID(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  const handleAmazonIDChange = (e) => {
    setAmazonID(e.target.value);
    console.log(e);
  };
  const handleFlipkartIDChange = (e) => {
    setFlipkartID(e.target.value);
    console.log(e);
  };
  const handleImageURLChange = (e) => {
    setImageURL(e.target.value);
  };

  const handleIsExoticProductChange = (e) => {
    setIsExoticProduct(e.target.value);
  };
  const handleIsPopularProductChange = (e) => {
    setIsPopularProduct(e.target.value);
  };

  const handleIsLastMinuteAddOnChange = (e) => {
    setIsLastMinuteAddOn(e.target.value);
  };

  const handleIsBestSellersOnChange = (e) => {
    setIsBestSellers(e.target.value);
  };

  const handleIsHotDealsOnChange = (e) => {
    setIsHotDeals(e.target.value);
  };

  const handleIsTrendingInYourAreaOnChange = (e) => {
    setIsTrendingInYourArea(e.target.value);
  };

  const handleIsTrendingOffersOnChange = (e) => {
    setIsTrendingOffers(e.target.value);
  };

  const handleIsHealthySnackingOnChange = (e) => {
    setIsHealthySnacking(e.target.value);
  };

  const handleSelectedBrandChange = (e) => {
    setSelectedBrand(e.target.value);
  };

  const validateInput = () => {
    if (productName === "") throw new Error("Product Name is required");
    if (productWeight === "") throw new Error("Product Weight is required");
    if (categoryID === -1) throw new Error("Category is required.");
    if (subcategoryID === -1) throw new Error("Subcategory is required.");
    if (imageURL === "") throw new Error("Image URL is required.");
  };

  useEffect(() => {
    (async function () {
      const categoryResponse = await GetProductCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      const subCategoryResponse = await GetProductSubCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      const brandResponse = await getallbrandnamewithoutpagination();
      // const tagResponse = await getalltagwithoutpagination();
      setCategories(categoryResponse.data.categories);
      setSubcategories(subCategoryResponse.data.subcategories);
      setVisibleSubcategories(subCategoryResponse.data.subcategories);
      setBrands(brandResponse.data);
      // const tagOptions = tagResponse.data.tags.map((tag) => {
      //   return { label: tag, value: tag };
      // })
      // setAllTags(tagOptions);
      // console.log("brandResponse.data.items?????", brandResponse);
    })();
  }, []);

  const fetchTags = async (pageToFetch = 1, searchTerm = "", reset = false) => {
    try {
      const tagResponse = await getAllTags(
        pageToFetch,
        itemsPerPage,
        searchTerm,
        localStorage.getItem("accessToken")
      );

      const fetchedTags = tagResponse.data.tags.items.map(tag => ({
        label: tag.title,
        value: tag.title
      }));

      setHasMore(fetchedTags.length === itemsPerPage);

      if (reset) {
        setAllTags(fetchedTags);
        setPage(2);
      } else {
        setAllTags(prev => [...prev, ...fetchedTags]);
        setPage(prev => prev + 1);
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleSearchChange = debounce((inputValue) => {
    setSearch(inputValue);
    fetchTags(1, inputValue, true); // reset = true
  }, 300);

  const handleScrollToBottom = () => {
    if (hasMore) {
      fetchTags(page, search);
    }
  };
  useEffect(() => {
    fetchTags(1, "", true);
  }, []);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      boxShadow: "none",
      border: "none",
      backgroundColor: "#fff", // Optional: or transparent
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, // To prevent it from hiding behind modals or dialogs
    }),
  };

  // console.log('selectedTags', selectedTags)
  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    try {
      response = await CreateProduct(
        {
          name: productName,
          weight: productWeight,
          categoryids: [categoryID],
          subcategoryids: [subcategoryID],
          imageurl: imageURL,
          jiomartid: jiomartID,
          blinkitid: blinkitID,
          bigbasketid: bigbasketID,
          zeptoid: zeptoID,
          swiggyinstamartid: swiggyInstaMartID,
          dmartid: dMartID,
          description: description,
          amazonid: amazonID,
          flipkartid: flipkartID,
          isexoticproduct: isExoticProduct,
          islastminuteaddon: isLastMinuteAddOn,
          isbestsellers: isBestSellers,
          ishotdeals: isHotDeals,
          istrendinginyourarea: isTrendingInYourArea,
          istrendingoffers: isTrendingOffers,
          ishealthysnacking: isHealthySnacking,
          swiggyweight: swiggyweight,
          brandname: selectedBrand,
          isPopularProduct: isPopularProduct,
          jiomarturl: jiomartUrl,
          dmartweight: dmartweight,
          tags: selectedTags.map(tag => tag.value),
        },
        localStorage.getItem("accessToken")
      );

      if (response.status === 201) {
        setProductViewMessage(response.data.message);
        navigate("/product");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Product</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/product" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Select Brand</label>
              <select
                value={selectedBrand}
                onChange={handleSelectedBrandChange}
                className="form-select custom-input"
                id="brandSelect"
              >
                <option value="">Select a Brand</option>
                {brands.map((brand) => (
                  <option key={brand._id} value={brand.brandname}>
                    {brand.brandname}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Product Name</label>
              <input
                type="text"
                value={productName}
                onChange={handleProductNameChange}
                className="form-control custom-input"
                id="catName"
                placeholder="Product Name"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Product Weight</label>
              <input
                type="text"
                value={productWeight}
                onChange={handleProductWeightChange}
                className="form-control  custom-input"
                id="catName"
                placeholder="Product Weight"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Image URL</label>
              <input
                type="text"
                value={imageURL}
                onChange={handleImageURLChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Image URL"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Category</label>
              <select
                className="form-select custom-input"
                value={categoryID}
                onChange={handleCategoryIDChange}
              >
                <option value={-1}>Select a Category</option>
                {categories?.map((item) => (
                  <option value={item.categoryid}>{item.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Subcategory</label>
              <select
                className="form-select custom-input"
                value={subcategoryID}
                onChange={handleSubcategoryIDChange}
              >
                <option value={-1}>Select a Subcategory</option>
                {visibleSubcategories?.map((item) => (
                  <option value={item.subcategoryid}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Blinkit ID</label>
              <input
                type="text"
                value={blinkitID}
                onChange={handleBlinkitIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Blinkit ID"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Bigbasket ID</label>
              <input
                type="text"
                value={bigbasketID}
                onChange={handleBigbasketIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Bigbasket ID"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Swiggy InstaMart ID</label>
              <input
                type="text"
                value={swiggyInstaMartID}
                onChange={handleSwiggyInstaMartIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Swiggy InstaMart ID"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Swiggy Weight</label>
              <input
                type="text"
                value={swiggyweight}
                onChange={handleSwiggyWeight}
                className="form-control  custom-input"
                id="catName"
                placeholder="Swiggy Weight"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Amazon URL</label>
              <input
                type="text"
                value={amazonID}
                onChange={handleAmazonIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Amazon URL"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Flipkart URL</label>
              <input
                type="text"
                value={flipkartID}
                onChange={handleFlipkartIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Flipkart URL"
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">DMart URL</label>
              <input
                type="text"
                value={dMartID}
                onChange={handleDMartIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="DMart URL"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Zepto ID</label>
              <input
                type="text"
                value={zeptoID}
                onChange={handleZeptoIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Zepto ID"
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Dmart Weight</label>
              <input
                type="text"
                value={dmartweight}
                onChange={handleDmartUrlChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="DMart Weight"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Jiomart Url</label>
              <input
                type="text"
                value={jiomartUrl}
                onChange={handleJiomartUrlChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Jiomart Url"
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Jio Mart ID</label>
              <input
                type="text"
                value={jiomartID}
                onChange={handleJiomartIDChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Jio Mart ID"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Popular Product</label>
              <select
                className="form-select custom-input"
                value={isPopularProduct}
                onChange={handleIsPopularProductChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Description</label>
              <textarea
                type="text"
                value={description}
                onChange={handleDescriptionChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Description"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Add Tag</label>
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={allTags}
                value={selectedTags}
                onChange={setSelectedTags}
                placeholder="Select Tags"
                className="custom-select custom-input"
                onInputChange={handleSearchChange}
                onMenuScrollToBottom={handleScrollToBottom}
                isLoading={hasMore}
                styles={customStyles}
              />
            </div>
          </div>
          {/* <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Is Hot Deals?</label>
              <select
                className="form-select custom-input"
                value={isHotDeals}
                onChange={handleIsHotDealsOnChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Is Healthy Snacking?</label>
              <select
                className="form-select custom-input"
                value={isHealthySnacking}
                onChange={handleIsHealthySnackingOnChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div>
          </div> */}
          {/* <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Is Trending In Your Area?</label>
              <select
                className="form-select custom-input"
                value={isTrendingInYourArea}
                onChange={handleIsTrendingInYourAreaOnChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Is Trending Offers?</label>
              <select
                className="form-select custom-input"
                value={isTrendingOffers}
                onChange={handleIsTrendingOffersOnChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div>
          </div> */}
          <div className="row">
            {/* <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Is Last Minute Addon?</label>
              <select
                className="form-select custom-input"
                value={isLastMinuteAddOn}
                onChange={handleIsLastMinuteAddOnChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div> */}
            {/* <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Is Exotic Product?</label>
              <select
                className="form-select custom-input"
                value={isExoticProduct}
                placeholder=""
                onChange={handleIsExoticProductChange}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div> */}
            {/* <div className="form-group col-sm-12 col-lg-12 mb-3">
              <label htmlFor="floatingInput">Description</label>
              <textarea
                type="text"
                value={description}
                onChange={handleDescriptionChange}
                className="form-control custom-input"
                id="floatingPassword"
                placeholder="Description"
              />
            </div> */}
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary save-btn text-uppercase px-4 my-3"
              >
                Add
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddProduct;
